import { LinearProgress, Stack } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SimpleAlert from "../../../components/display/SimpleAlert";
import NotFoundFullScreenMessage from "../../../components/fullScreenMessage/NotFoundFullScreenMessage";
import { PET_BIOMETRICS } from "../../../enums/ApiPaths";
import { PET_BIOMETRICS_DATA } from "../../../enums/QueryKeys";
import { fetchPetBiometrics } from "../../../enums/queryFunction/Fetch";
import useUser from "../../../hooks/useUser";
import AddBiometricsDialog from "./AddBiometricsDialog";
import BiometricsView from "./BiometricsView";

export default function PetBiometrics() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { roles } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: [PET_BIOMETRICS_DATA + id],
    queryFn: () => fetchPetBiometrics(id),
    staleTime: Infinity,
  });

  const biometrics = useMemo(
    () =>
      data?.map((biometrics) => (
        <BiometricsView
          key={biometrics?.id}
          data={biometrics}
          queryKey={PET_BIOMETRICS_DATA}
          apiKey={PET_BIOMETRICS}
          id={id}
          outlined
        />
      )),
    [data, id]
  );

  if (isLoading) {
    return <LinearProgress />;
  }

  if (error) {
    if (
      error?.response?.status === 403 ||
      String(error?.response?.data).toUpperCase() === String("FORBIDDEN")
    ) {
      navigate(-1);
      return;
    }
    return <NotFoundFullScreenMessage testId="pet.biometrics-filtering.error-message"/>;
  }

  return (
    <React.Fragment>
      {roles?.user ? null : (
        <Stack direction="row" justifyContent="flex-start" mb={3}>
          <AddBiometricsDialog petId={id} />
        </Stack>
      )}
      {error ? (
        <SimpleAlert message={"ErrorFetchingBiometricsList"}  testId="pet.biometrics.error-alert" />
      ) : biometrics.length > 0 ? (
        biometrics
      ) : (
        <SimpleAlert
          message={"NoBiometricsCurrentlyAvailable"}
          severity={"info"}
          testId="pet.biometrics.empty-alert"
        />
      )}
    </React.Fragment>
  );
}
